<template>
  <DialogoFormulario
    ref="dialog"
    title="Solicitar transferência"
    :width="500"
    :handler="handler"
  >
    <template v-slot="{ form, errors }">
      <v-row dense>
        <v-col cols="12" sm="6" md="8">
          <v-autocomplete
            v-model="form.produto"
            label="Produto"
            outlined
            :items="produtos"
            item-value="produto_id"
            item-text="produto_nome"
            :error-messages="errors.produto_id"
          ></v-autocomplete>
        </v-col>

        <v-col>
          <v-text-field
            v-model="form.quantidade"
            label="Qtd"
            type="number"
            outlined
            :error-messages="errors.quantidade"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-text-field
        label="Origem"
        outlined
        :value="localEstoque.nome"
        disabled
        :error-messages="errors.local_estoque_origem_id"
      ></v-text-field>

      <BuscarOuCadastrarLocalDeEstoque
        v-model="form.endereco_destino"
        label="Destino"
        outlined
        :error-messages="errors.local_estoque_destino_id"
      />

      <v-row dense>
        <v-col cols="12" sm="5">
          <v-text-field
            v-model="form.data"
            label="Data"
            outlined
            type="date"
            :error-messages="errors.data_solicitacao_entrega"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import BuscarOuCadastrarLocalDeEstoque from "@/components/locacoes/localEstoque/BuscarOuCadastrarLocalDeEstoque.vue";
import api from "@/services/locacoes.js";

export default {
  mixins: [],

  components: {
    DialogoFormulario,
    BuscarOuCadastrarLocalDeEstoque
  },

  props: {
    produtos: Array,
    localEstoque: Object
  },

  data() {
    return {};
  },

  methods: {
    open(produto_id = null) {
      this.$refs.dialog.open({
        produto: produto_id
      });
    },

    async handler(form) {
      const transferencia = await api.transferencias.adicionar({
        local_estoque_origem_id: this.localEstoque.id,
        local_estoque_destino_id: form.endereco_destino
          ? form.endereco_destino.id
          : null,
        produto_id: form.produto,
        quantidade: form.quantidade,
        data_solicitacao_entrega: form.data
      });

      this.$emit("adicionado", transferencia);
    }
  },

  computed: {}
};
</script>
